const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = "/branch-working-days";

export const getBranchWorkingDays = async (token, branchId) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/${branchId}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        });

        if (!response.ok) {
            const errText = await response.text();
            throw new Error(errText || "فشل تحميل أوقات الدوام");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message || "حدث خطأ أثناء تحميل أوقات الدوام");
    }
};

export const updateBranchWorkingDays = async (token, branchId, workingDays) => {
    try {
        const response = await fetch(`${BASE_URL}${API_URL}/${branchId}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(workingDays),
        });

        if (!response.ok) {
            const errText = await response.text();
            throw new Error(errText || "فشل تحديث أوقات الدوام");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message || "حدث خطأ أثناء تحديث أوقات الدوام");
    }
};
export const deleteWorkingDay = async (token, id) => {
    try {
        const response = await fetch(`${BASE_URL}/working-days/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        });

        if (!response.ok) {
            const errText = await response.text();
            throw new Error(errText || "فشل حذف اليوم");
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message || "حدث خطأ أثناء حذف اليوم");
    }
};
